var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemperatureSensor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e1ebf2",
    d: "M20,22.214c-2.481,0-4.5-2.019-4.5-4.5V6c0-2.481,2.019-4.5,4.5-4.5s4.5,2.019,4.5,4.5v11.714 C24.5,20.196,22.481,22.214,20,22.214z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M20,2c2.206,0,4,1.794,4,4v11.714c0,2.206-1.794,4-4,4s-4-1.794-4-4V6C16,3.794,17.794,2,20,2 M20,1c-2.75,0-5,2.25-5,5v11.714c0,2.75,2.25,5,5,5s5-2.25,5-5V6C25,3.25,22.75,1,20,1L20,1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f78f8f",
    d: "M20,38.5c-4.136,0-7.5-3.364-7.5-7.5c0-2.283,1.025-4.415,2.813-5.85L15.5,25v-9.5h9V25l0.187,0.15 C26.475,26.585,27.5,28.717,27.5,31C27.5,35.136,24.136,38.5,20,38.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c74343",
    d: "M24,16v8.76v0.48l0.374,0.3C26.043,26.879,27,28.869,27,31c0,3.86-3.14,7-7,7s-7-3.14-7-7 c0-2.131,0.957-4.121,2.626-5.46L16,25.24v-0.48V16H24 M25,15H15v9.76c-1.827,1.466-3,3.714-3,6.24c0,4.418,3.582,8,8,8 s8-3.582,8-8c0-2.525-1.173-4.773-3-6.24V15L25,15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c74343",
    d: "M19 19H25V20H19zM19 23H25V24H19z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M19 11H25V12H19zM19 7H25V8H19z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureSensor);
export default __webpack_public_path__ + "static/media/temperatureSensor.80e2918905382a76139414eb1b1f2e9b.svg";
export { ForwardRef as ReactComponent };